export default __webpack_public_path__ + "static/media/10_tag_outdoor-bath.2a63e85b.svg";